import React from "react";
import PrimaryOrderOld from "./PrimaryOrderOld";
import PrimaryOrder from "./PrimaryOrder";

const PrimaryOrderContainer = () => {
  const ConfigDictionary = JSON.parse(
    localStorage.getItem("ConfigDictionary") ?? "{}"
  );
  const PrimaryOrderV2 = ConfigDictionary?.PrimaryOrderV2 ?? false;

  return PrimaryOrderV2 ? (
    <PrimaryOrder />
  ) : (
    <PrimaryOrderOld />
  );
};

export default PrimaryOrderContainer;
